module.exports = __webpack_public_path__ + "media/images/signed-8c66e34d4be3556cdd2ad52f03094194.svg";